var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/auction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/auction",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72050138,19.0511086 C10.5348152,19.0511086 11.1949471,19.7112405 11.1949471,20.5255543 C11.1949471,21.3398682 10.5348152,22 9.72050138,22 L3.83183743,22 C3.01752356,22 2.35739175,21.3398682 2.35739175,20.5255543 C2.35739175,19.7112405 3.01752356,19.0511086 3.83183743,19.0511086 L9.72050138,19.0511086 Z M11.7456112,2.41494411 L15.1691952,5.84205908 C15.9492717,6.6229405 15.9492717,7.88814594 15.1691952,8.66902737 L13.456,10.383 L19.9584841,16.8918329 C20.5338711,17.4678136 20.5338711,18.4010333 19.9584841,18.977014 C19.7070877,19.2286699 19.3872627,19.3703183 19.0588346,19.4019284 L18.9177273,19.4087385 C18.540967,19.4089327 18.1641326,19.2653978 17.8765259,18.9780876 L11.373,12.468 L9.66403789,14.179865 C8.88339216,14.9613162 7.61706237,14.9619691 6.83561115,14.1813234 L3.41202719,10.7542084 C2.63195066,9.97332702 2.63195066,8.70812158 3.41202719,7.92724015 L8.91718445,2.41640257 C9.69783019,1.63495135 10.96416,1.63429837 11.7456112,2.41494411 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.f79f34ac929baacb01d93a9481a8d069.svg";
export { ForwardRef as ReactComponent };